import React from "react";
import HeroBg from "../../assets/hero.jpg";
import Button from "../common/Button";

const Hero = () => {
  return (
    <section
      className="relative overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${HeroBg})` }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/35" />

      <div className="relative mx-auto flex min-h-[70vh] max-w-[1720px] items-center justify-center px-4 py-14 sm:min-h-[80vh] sm:px-6 sm:py-16 md:px-10 lg:min-h-screen lg:px-14">
        <div className="max-w-5xl text-center text-white">
          <h1 className="text-[28px] font-bold leading-tight sm:text-4xl sm:leading-snug md:text-5xl md:leading-[56px]">
            Innovative Products to Power STEAM Learning
          </h1>

          <p className="mx-auto mt-4 max-w-3xl text-base tracking-[1%] text-white/90 sm:mt-5 sm:text-xl sm:leading-7 md:text-2xl">
            Hands-on kits, interactive games, and immersive VR labs designed to
            spark creativity & innovation
          </p>

          <div className="mt-8 flex justify-center sm:mt-10">
            <Button
              btnText="Explore Our Products"
              btnClassName="rounded-full bg-[#FF6636] px-6 py-3 text-base font-medium leading-6 text-white sm:px-8 sm:py-3.5 sm:text-xl md:px-[35px] md:py-4 md:text-2xl md:leading-7"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
